import React from 'react';
import ReactDOM from 'react-dom';
import { ManageTagGroupsComponent } from './ManageTextGroupsComponent';

class TagsManager extends HTMLElement {
  constructor() {
    super();

    this.renderManageTagGroups = this.renderManageTagGroups.bind(this);
  }

  connectedCallback() {
    let group_id = document.querySelector("#object_id").value

    this.innerHTML = `
      <style>
        tags-manager p {
          margin-bottom: 20px;
        }
        tags-manager #tags_table_wrapper {
          margin-top: 20px;
        }
      </style>
      <div id="manage_tags_container">
        <div class="row">
          <div class="form-group form-horizontal col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
            <div class="errors"></div>
            <h3 style="float: left;width: 100%;">
              Manage Tags
            </h3>
            <p>A tag is a custom label that you assign to a campaign. Tags can be used to help organize and identify your campaigns.</p>
            <div class="row">
              <div class="col-sm-3 no-gutters">
                <select class="form-control" type="text" name="tag_group_id" is="tag-groups-select" data-group_id="${group_id}">
                </select>
              </div>
              <div class="col-sm-3">
                <input class="form-control" placeholder="Enter Tag Name" type="text" name="tag_name" data-cy=tags_create_value>
              </div>
              <div class="col-sm-4">
                <a id="add_tag" class="btn btn-primary" data-cy=tags_create_btn>Add Tag</a>
              </div>
              <div class="col-sm-2">
                <button id="manage_tag_groups" class="btn btn-link">Manage Tag Groups</button>
              </div>
            </div>
          </div>
        </div>
        
        <table id="tags_table" class="table datatable" style="width:100%">
          <thead>
            <tr>
              <th>Tag Group</th><th>Tag</th><th>Active</th><th>Actions</th>
            </tr>
          </thead>
        </table>
      </div>
        
      <div id="manage_tag_groups_react_root" style="display: none;"></div>
    `;
    
    this.table = $("#tags_table").DataTable({
      "ajax": `/admin/groups/${group_id}/tags`, // Use attribute href from element.
      dom: 'lftip',
      "autoWidth": false,
      "columns": [
        {
          "render": function ( data, type, row ) {
            return row.tag_group.name
          }
        },
        {
          "data": "name"
        },
        {
          data: "is_used",
          "render": function ( data, type, row ) {
            return ( type === 'display') ? '<span class="fa '+((data==true) ? "fa-check":"fa-times")+'"></span>' : data
          }, // feature
          "class": "text-center",
        },
        {
          render: function( data, type, row ) {
            return row.is_used ? "" : "<a href='#delete' data-cy=tag_delete>Delete</a>"
          },
          width: "10%"
        }
      ],
      order: [[ 0, "desc" ]]
    });

    $(this.querySelector("table")).on("click", "a[href='#delete']", function(e) {
      e.preventDefault();
      let row = this.table.row(e.target.closest('tr'));
      this.remove(row);
    }.bind(this));

    this.querySelector("#add_tag").addEventListener("click", function(e) {
      e.preventDefault();
      this.add();
    }.bind(this));

    this.querySelector('#manage_tag_groups').addEventListener('click', this.renderManageTagGroups);
  }

  async add() {
    let group_id = document.querySelector("#object_id").value
    let tag_name = this.querySelector("input[name='tag_name']").value.trim();
    let tag_group_id = this.querySelector("select[name='tag_group_id']").value.trim();
    this.querySelector(".errors").innerHTML = "";
    if(tag_name == "") {
      this.querySelector(".errors").innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              <strong>Warning!</strong> Tag is incomplete.
            </div>`
      return;
    }
    let tag = {
      "tag_group_id": tag_group_id,
      "name": tag_name
    };
    
    let res = await fetch(`/admin/groups/${group_id}/tags`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'POST',
        body: JSON.stringify(tag)
      })
    let data = await res.json();

    if(data["error"] == "RecordNotUnique") {
      this.querySelector(".errors").innerHTML = `<div class="alert alert-danger alert-dismissible" role="alert">
              <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
              <strong>Warning!</strong> Tag already exists.
            </div>`
    } else {
      Common.notify("New tag created", 'success');
      let tagGroupsDataBinder = new DataBinder(`/admin/groups/${group_id}/tag_groups`, true)
      tagGroupsDataBinder.fetchData();
      this.table.row.add(data).draw();
      this.clear();
    }
  }

  clear() {
    this.querySelector("input[name='tag_name']").value = "";
  }

  async remove(row) {
    let row_data = row.data();

    if(confirm(`Delete the tag "${row_data["name"]}"`)) {
      let res = await fetch(`/admin/groups/${row_data["auto_group_id"]}/tags/${row_data["tag_id"]}`, {
        headers: {'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                  'Content-type': 'application/json'},
        method: 'DELETE'
      });
      let data = await res.json()
      if(data["success"]) {
        Common.notify("Successfully deleted tag", 'success');
        this.table.row(row).remove().draw();
      }
    }
  }

  renderManageTagGroups() {
    const manageTagsContainer = this.querySelector('#manage_tags_container');
    const manageTagGroupsRoot = this.querySelector('#manage_tag_groups_react_root');

    manageTagsContainer.style.display = 'none';
    manageTagGroupsRoot.style.display = 'block';

    ReactDOM.render(
      React.createElement(ManageTagGroupsComponent, {
        hideManageTagGroups: this.hideManageTagGroups.bind(this),
        groupId: document.querySelector("#object_id").value,
        reloadTagsTable: this.reloadTable.bind(this)
      }),
      manageTagGroupsRoot
    );
  }

  hideManageTagGroups() {
    const manageTagsContainer = this.querySelector('#manage_tags_container');
    const manageTagGroupsRoot = this.querySelector('#manage_tag_groups_react_root');

    manageTagsContainer.style.display = 'block';
    manageTagGroupsRoot.style.display = 'none';

    ReactDOM.unmountComponentAtNode(manageTagGroupsRoot);
  }

  reloadTable() {
    this.table.ajax.reload();
  }
}

customElements.define("tags-manager", TagsManager)

class TagGroupsSelect extends HTMLSelectElement {
  constructor() {
    super();
    this.template = document.createElement('template');
  }

  // NOT TESTED
  requestUpdate(data){
    this.data = data;

    let options = this.data.data.map(tag_group => `<option value="${tag_group.tag_group_id}">${tag_group.name}</option>`).join("")
    this.template.innerHTML = this.data.data.length > 0 ? `${options}` : `<option value="null">Default</option>`
    
    Array.from(this.options).map(opt=> {
        opt.parentNode.removeChild(opt);
    });

    this.appendChild(this.template.content.cloneNode(true));
    if(this.selectedOptions.length == 0) {
      this.value = "null"
    }
  }

  async connectedCallback() {
    this.data_binder = new DataBinder(`/admin/groups/${this.dataset.group_id}/tag_groups`, true);
    this.data_binder.register(this);
    if(this.data_binder.data) this.requestUpdate(this.data_binder.data);
  }

  disconnectedCallback(){
    this.data_binder.unregister(this);
  }
}

customElements.define('tag-groups-select', TagGroupsSelect, {extends: 'select'})